import React, { useState, useEffect, memo, Fragment, useMemo } from "react";
import { Row, Col, Dropdown, Button, Form, Image } from "react-bootstrap";
import "./StatistikHeader.css";
import Card from "../../components/Card";
import { FaChartBar, FaCube, FaMoneyBill, FaDollarSign } from "react-icons/fa";

import ExportBarChart from "./components/custom-bar-chart";
import ExportDonutChart from "./components/custom-donut-chart";

//Dashboar Service
import DashboardService from "../../services/pbumku/DashboardService";

// Chart Nilai Ekspor
import NilaiExportChart from "./components/nilai-export-chart";

// Chart Frequensi Ekspor
import FrequensiExsporChart from "./components/frequensi-exspor-chart";

// AOS
import AOS from "aos";
import "../../../node_modules/aos/dist/aos";
import "../../../node_modules/aos/dist/aos.css";

//apexcharts
import Chart from "react-apexcharts";

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";

//Count-up
import CountUp from "react-countup";

// Redux Selector / Action
import { useSelector } from "react-redux";

// Import selectors & action from setting store
import * as SettingSelector from "../../store/setting/selectors";
import { get } from "sortablejs";

// install Swiper modules
SwiperCore.use([Navigation]);

const DashEkspor = memo((props) => {
  let DashService = useMemo(() => new DashboardService(), []);
  const [frequensi, setFrequensi] = useState([]); // data frequensi
  const [frequensiNegara, setFrequensiNegara] = useState([]);
  const [frequensiUpt, setFrequensiUpt] = useState([]); // data frequensi upt
  const [frequensiTrader, setFrequensiTrader] = useState([]);
  const [jumfreq, setJumfreq] = useState(0); // jumlah data frequensi
  const [jumVol, setJumVol] = useState(0); // jumlah data volume
  const [nilaiIDR, setNilaiIDR] = useState(0); // Nilai Rupiah
  const [nilaiUSD, setNilaiUSD] = useState(0); // Nilai USD
  const [bulanTahun, setBulanTahun] = useState([]);
  const [namaUPT, setNamaUPT] = useState(null);
  const [isVisibleUpt, setIsVisibleUpt] = useState(false); // check yang login, dari upt atau dari pusat
  const [isNol, setIsNol] = useState(false); // data sudah ada atau belum
  const [isTrader, setIsTrader] = useState(false); // check yang login, dari trader atau bukan
  const [bentuk, setBentuk] = useState([]);
  const [tahuns, setTahuns] = useState([]);
  const [tahunsHonnest, setTahunsHonnest] = useState([]);
  const [komoditasUnggulan, setKomoditasUnggulan] = useState([]);

  // Variabel untuk common export
  const [commonExport, setCommonExport] = useState([]);
  const [commonKategori, setCommonKategori] = useState("kel_ikan");
  const [commonOrderBy, setCommonOrderBy] = useState("jumlah");
  const [commonLimit, setCommonLimit] = useState(5);

  // Variabel untuk baca tanggal default
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-11

  // Tahun HACCP
  const [yearHACCP, setYearHACCP] = useState(today.getFullYear());

  // SMKHP
  const [startOfMonth, setStartOfMonth] = useState(new Date(year, month, 1));
  const [endOfMonth, setEndOfMonth] = useState(new Date(year, month + 1, 0)); // 0 = last day of previous month

  // fungsi untuk baca tanggal default untuk PB-UMKU
  const getStartOfYear = () => {
    const now = new Date();
    return `${now.getFullYear()}-01-01`;
  };

  const getToday = () => {
    const now = new Date();
    return now.toISOString().slice(0, 10);
  };

  // variabel untuk x axis
  const [xAxis, setXAxis] = useState(1);

  // variable baca role
  const [role, setRole] = useState(localStorage.getItem("role"));

  // variabel baca upt
  const [kdUPT, setKdUPT] = useState(localStorage.getItem("kdUnit"));

  const formatDate = (date, isEndOfDay = false) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // bulan dimulai dari 0
    const dd = String(date.getDate()).padStart(2, "0");
    const time = isEndOfDay ? "23:59:59" : "00:00:00";
    return `${yyyy}-${mm}-${dd} ${time}`;
  };

  const formatDateInput = (date) => {
    const offset = date.getTimezoneOffset(); // dalam menit
    const localDate = new Date(date.getTime() - offset * 60 * 1000);
    return localDate.toISOString().slice(0, 10);
  };

  const formatTanggalIndonesia = (tanggalStr) => {
    const bulanIndo = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    const tanggal = new Date(tanggalStr);
    const hari = String(tanggal.getDate()).padStart(2, "0");
    const bulan = bulanIndo[tanggal.getMonth()];
    const tahun = tanggal.getFullYear();

    return `${hari} ${bulan} ${tahun}`;
  };

  const [selectedBulan, setSelectedBulan] = useState(
    today.toLocaleString("id-ID", { month: "long" }) +
    " " +
    today.toLocaleString("default", { year: "numeric" })
  );
  const [selectedTahun, setSelectedTahun] = useState(
    today.toLocaleString("default", { year: "numeric" })
  );
  const monthNames = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MEI",
    "JUN",
    "JUL",
    "AGU",
    "SEP",
    "OKT",
    "NOV",
    "DES",
  ];

  // template startDate dan endDate
  const [tempStartDate, setTempStartDate] = useState(
    formatDateInput(startOfMonth)
  );
  const [tempEndDate, setTempEndDate] = useState(formatDateInput(endOfMonth));

  // template startDate dan endDate PBUMKU
  const [tempStartDateUmku, setTempStartDateUmku] = useState(getStartOfYear());
  const [tempEndDateUmku, setTempEndDateUmku] = useState(getToday());

  // varibel Range Periode
  const [rangePeriode, setRangePeriode] = useState(`Bulan ${selectedBulan}`);
  const [rangePeriodeUmku, setRangePeriodeUmku] = useState(
    `Tahun ${new Date().getFullYear()}`
  );

  useEffect(() => {
    getRole();
    getFrequensi();
    getFrequensiNegara();
    getFrequensiUpt();
    getFrequensiTrader();
    getJumlahFrequensi();
    getJumlahVolume();
    getNilai();
    getBulanTahun();
    getNamaUPT();
    getTahun();
    getTahunHonnest();
    getKetBentuk();
    getKomoditasUnggulan();
    getCommonGroupingExport();
  }, []);

  useEffect(() => {
    getFrequensi();
    getFrequensiNegara();
    getFrequensiUpt();
    getFrequensiTrader();
    getJumlahFrequensi();
    getJumlahVolume();
    getNilai();
    getBulanTahun();
    getNamaUPT();
    getTahun();
    getKetBentuk();
    getKomoditasUnggulan();
    getCommonGroupingExport();
  }, [startOfMonth, endOfMonth]);

  useEffect(() => {
    getCommonGroupingExport();
  }, [commonKategori, commonOrderBy, commonLimit]);

  const getFrequensi = async () => {
    let response;
    if (xAxis === 1) {
      response = await DashService.getFrequensi(
        kdUPT,
        formatDate(startOfMonth),
        formatDate(endOfMonth, true)
      );
    } else {
      response = await DashService.getFrequensiBulan(
        kdUPT,
        formatDate(startOfMonth),
        formatDate(endOfMonth, true)
      );
    }
    setFrequensi(response.data);
  };

  const getFrequensiNegara = async () => {
    const response = await DashService.getFrequensiNegara(
      kdUPT,
      formatDate(startOfMonth),
      formatDate(endOfMonth, true)
    );
    setFrequensiNegara(response.data);
  };

  const getFrequensiUpt = async () => {
    const response = await DashService.getFrequensiUpt(
      kdUPT,
      formatDate(startOfMonth),
      formatDate(endOfMonth, true)
    );
    setFrequensiUpt(response.data);
  };

  const getFrequensiTrader = async () => {
    const response = await DashService.getFrequensiTrader(
      kdUPT,
      formatDate(startOfMonth),
      formatDate(endOfMonth, true)
    );
    setFrequensiTrader(response.data);
  };

  const getJumlahFrequensi = async () => {
    const response = await DashService.getJumlahFrequensi(
      kdUPT,
      formatDate(startOfMonth),
      formatDate(endOfMonth, true)
    );
    setJumfreq(response.data);
    if (response.data === 0) {
      setIsNol(true);
    }
  };

  const getJumlahVolume = async () => {
    const response = await DashService.getJumlahVolume(
      kdUPT,
      formatDate(startOfMonth),
      formatDate(endOfMonth, true)
    );
    setJumVol(response.data.totalVolume);
  };

  const getNilai = async () => {
    const response = await DashService.getJumlahNilai(
      kdUPT,
      formatDate(startOfMonth),
      formatDate(endOfMonth, true)
    );
    setNilaiIDR(response.data.totalNilaiIDR);
    setNilaiUSD(response.data.totalNilaiUSD);
  };

  const getBulanTahun = async () => {
    const response = await DashService.getBulanTahun();
    setBulanTahun(response.data);
  };

  const getNamaUPT = async () => {
    const cleanedKdUPT = kdUPT.trim();
    const excludedUPTs = new Set(["00.1", "00.2", "00.3"]);
    const isExcluded = excludedUPTs.has(cleanedKdUPT);

    if (!isExcluded) {
      const kdUnit = localStorage.getItem("kdUnit");
      try {
        const response = await DashService.getNamaUPT(cleanedKdUPT);
        setNamaUPT(response.data.NM_PENDEK_BARU);
        setIsVisibleUpt(true);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const formatDateShort = (date) => {
    const d = new Date(date);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const getCommonGroupingExport = async () => {
    try {
      const response = await DashService.getCommonGrouping({
        kategori: commonKategori,
        tglAwal: formatDateShort(startOfMonth),
        tglAkhir: formatDateShort(endOfMonth),
        kdUpt: kdUPT || null,
        limit: commonLimit,
        orderBy: commonOrderBy
      });

      setCommonExport(response.data);
    } catch (error) {
      console.error("Gagal fetch data grouping:", error);
    }
  };

  const getRole = () => {
    const roleaturan = localStorage.getItem("role");
    const includedTrader = new Set(["4", "5"]);
    const isIncluded = includedTrader.has(roleaturan);
    if (isIncluded) {
      console.log("ini trader");
      setIsTrader(true);
    } else {
      setIsTrader(false);
    }
  };

  const getKetBentuk = async () => {
    const response = await DashService.getKetBentuk(
      kdUPT,
      formatDate(startOfMonth),
      formatDate(endOfMonth, true)
    );
    setBentuk(response.data);
  };

  const getKomoditasUnggulan = async () => {
    const response = await DashService.getKomoditasUnggulan(
      kdUPT,
      formatDate(startOfMonth),
      formatDate(endOfMonth, true),
      10
    );
    setKomoditasUnggulan(response.data);
  };

  const getTahun = async () => {
    const response = await DashService.getTahun();
    setTahuns(response.data);
  };

  const getTahunHonnest = async () => {
    const response = await DashService.getTahunHonest();
    setTahunsHonnest(response.data);
  };

  useSelector(SettingSelector.theme_color);

  const getVariableColor = () => {
    let prefix =
      getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
    if (prefix) {
      prefix = prefix.trim();
    }
    const color1 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary`
    );
    const color2 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}info`
    );
    const color3 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary-tint-20`
    );
    const color4 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}warning`
    );
    return {
      primary: color1.trim(),
      info: color2.trim(),
      warning: color4.trim(),
      primary_light: color3.trim(),
    };
  };
  const variableColors = getVariableColor();

  const colors = [variableColors.primary, variableColors.info];
  useEffect(() => {
    return () => colors;
  });

  useEffect(() => {
    AOS.init({
      startEvent: "DOMContentLoaded",
      disable: function () {
        var maxWidth = 996;
        return window.innerWidth < maxWidth;
      },
      throttleDelay: 10,
      once: true,
      duration: 700,
      offset: 10,
    });
  });

  //chart frequensi
  const chartFrequensi = useMemo(() => {
    const isValidFrequensi = Array.isArray(frequensi) && frequensi.length > 0;
    if (!isValidFrequensi) return null;

    return {
      options: {
        chart: {
          fontFamily: '"Inter", sans-serif',
          toolbar: { show: false },
          sparkline: { enabled: false },
        },
        colors: colors,
        dataLabels: { enabled: false },
        stroke: { curve: "smooth", width: 3 },
        yaxis: {
          show: true,
          labels: {
            show: true,
            minWidth: 19,
            maxWidth: 19,
            style: { colors: "#8A92A6" },
            offsetX: -5,
          },
        },
        legend: { show: false },
        xaxis: {
          labels: {
            minHeight: 22,
            maxHeight: 22,
            show: true,
            style: { colors: "#8A92A6" },
          },
          lines: { show: false },
          categories:
            xAxis === 1
              ? frequensi.map((item) => item?.TANGGAL)
              : frequensi.map((item) => monthNames[item?.BULAN - 1] ?? "-"),
        },
        grid: { show: false },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "vertical",
            shadeIntensity: 0,
            inverseColors: true,
            opacityFrom: 0.4,
            opacityTo: 0.1,
            stops: [0, 50, 80],
            colors: colors,
          },
        },
        tooltip: {
          enabled: true,
          x: {
            formatter: (value, { dataPointIndex }) => {
              const label =
                xAxis === 1
                  ? frequensi[dataPointIndex]?.TANGGAL
                  : monthNames[frequensi[dataPointIndex]?.BULAN - 1]; // ← perbaiki di sini
              return xAxis === 1 ? `Tanggal ${label}` : `Bulan ${label}`;
            },
          },
        },
      },
      series: [
        {
          name: "Jumlah",
          data: frequensi.map((item) => item?.JUMLAH),
        },
      ],
    };
  }, [frequensi, xAxis, colors]);

  const chartVolume = useMemo(() => {
    // Validasi data
    const isValidFrequensi = Array.isArray(frequensi) && frequensi.length > 0;
    if (!isValidFrequensi) return null;

    const categories =
      xAxis === 1
        ? frequensi.map((item) => item?.TANGGAL ?? "-")
        : frequensi.map((item) =>
          typeof item?.BULAN === "number" &&
            item.BULAN >= 1 &&
            item.BULAN <= 12
            ? monthNames[item.BULAN - 1]
            : "-"
        );

    const volumeData = frequensi.map((item) => item?.NETTO ?? 0);

    return {
      options: {
        chart: {
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        colors: colors,
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "28%",
            endingShape: "rounded",
            borderRadius: 5,
          },
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: categories,
          labels: {
            minHeight: 20,
            maxHeight: 20,
            style: {
              colors: "#8A92A6",
            },
          },
        },
        yaxis: {
          title: {
            text: "",
          },
          labels: {
            minWidth: 19,
            maxWidth: 19,
            style: {
              colors: "#8A92A6",
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          x: {
            formatter: function (value, { dataPointIndex }) {
              const label =
                xAxis === 1
                  ? frequensi[dataPointIndex]?.TANGGAL
                  : monthNames[frequensi[dataPointIndex]?.BULAN - 1];
              return xAxis === 1 ? `Tanggal ${label}` : `Bulan ${label}`;
            },
          },
          y: {
            formatter: function (val) {
              return (
                (val / 1000).toLocaleString("id-ID", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) + " Ton"
              );
            },
          },
        },
      },
      series: [
        {
          name: "Volume",
          data: volumeData,
        },
      ],
    };
  }, [frequensi, xAxis, colors]);

  const chartBentuk = {
    options: {
      labels: bentuk
        .filter((item) => item.ket_bentuk)
        .map((item) => item.ket_bentuk),
      chart: {
        type: "donut",
      },
      tooltip: {
        y: {
          formatter: (val) =>
            `${val.toLocaleString("id-ID", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} Ton`,
        },
      },
    },
    series: bentuk
      .filter((item) => item.ket_bentuk)
      .map((item) => item.totalVolume / 1000),
  };

  const handleSelect = (value) => {
    setSelectedBulan(value);

    const bulanMap = {
      Januari: 0,
      Pebruari: 1,
      Maret: 2,
      April: 3,
      Mei: 4,
      Juni: 5,
      Juli: 6,
      Agustus: 7,
      September: 8,
      Oktober: 9,
      November: 10,
      Desember: 11,
    };

    const [namaBulan, tahunStr] = value.split(" ");
    const tahun = parseInt(tahunStr);
    const bulan = bulanMap[namaBulan];

    if (bulan === undefined || isNaN(tahun)) {
      return null;
    }

    setStartOfMonth(new Date(tahun, bulan, 1));
    setEndOfMonth(new Date(tahun, bulan + 1, 0));
    setXAxis(1);

    // ← Gunakan nilai langsung
    setRangePeriode(`Bulan ${namaBulan} Tahun ${tahun}`);
  };

  const handleSelectTahun = (value) => {
    setSelectedTahun(value);
    setStartOfMonth(new Date(`${value}-01-01`));
    setEndOfMonth(new Date(`${value}-12-31`));
    setXAxis(2);
    setRangePeriode(`Tahun ${selectedTahun}`);
  };

  const handleSelectTahunHonnest = (value) => {
    setYearHACCP(value);
  };

  const handleClickButton = () => {
    if (!tempStartDate || !tempEndDate) {
      alert("Harap isi kedua tanggal.");
      return;
    }

    const tglAwal = new Date(tempStartDate);
    const tglAkhir = new Date(tempEndDate);

    // Validasi akhir >= awal
    if (tglAkhir < tglAwal) {
      alert("Tanggal akhir harus lebih besar atau sama dengan tanggal awal.");
      return;
    }

    // Validasi tahun sama
    if (tglAwal.getFullYear() !== tglAkhir.getFullYear()) {
      alert("Periode harus dalam tahun yang sama.");
      return;
    }

    // Set xAxis: 1 = harian, 2 = bulanan
    const isSameMonth = tglAwal.getMonth() === tglAkhir.getMonth();
    setXAxis(isSameMonth ? 1 : 2);

    // ✅ Baru ubah state utama → trigger useEffect
    setStartOfMonth(tglAwal);
    setEndOfMonth(tglAkhir);
    setRangePeriode(
      `${formatTanggalIndonesia(tglAwal)} s/d ${formatTanggalIndonesia(
        tglAkhir
      )}`
    );
  };

  const handleClickButtonUmku = () => {
    const bulanIndonesia = new Intl.DateTimeFormat("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

    if (!tempStartDateUmku || !tempEndDateUmku) {
      alert("Tanggal awal dan akhir harus diisi!");
      return;
    }

    const start = new Date(tempStartDateUmku + "T00:00:00"); // buat Date dari string
    const end = new Date(tempEndDateUmku + "T23:59:59");

    if (start > end) {
      alert("Tanggal awal tidak boleh lebih besar dari tanggal akhir.");
      return;
    }

    if (start.getFullYear() !== end.getFullYear()) {
      alert("Periode tidak boleh lintas tahun.");
      return;
    }

    const formattedStart = bulanIndonesia.format(new Date(tempStartDateUmku));
    const formattedEnd = bulanIndonesia.format(new Date(tempEndDateUmku));

    // setRangePeriodeUmku(`Periode ${tempStartDateUmku} s.d ${tempEndDateUmku} (Tahun ${start.getFullYear()})`);
    setRangePeriodeUmku(`Periode ${formattedStart} s.d ${formattedEnd}`);
  };

  const toInputDate = (date) => {
    if (!(date instanceof Date) || isNaN(date)) return ""; // hindari error jika date tidak valid
    return date.toISOString().slice(0, 10); // format YYYY-MM-DD
  };

  // dropdown label mapping kaegori
  const labelMapKategori = {
    negara: "Negara Tujuan Ekspor",
    upt: "Unit Pelaksana Teknis",
    trader: "Eksportir",
    kel_ikan: "Komoditas"
  };

  // dropdown label mapping berdasarkan
  const labelMapBerdasarkan = {
    jumlah: "Frekuensi",
    netto: "Volume (Ton)",
    nilaiIDR: "Nilai Rupiah (Juta)",
    nilaiUSD: "nilai USD"
  };

  return (
    <Fragment>
      {!isTrader ? (
        <Fragment>
          {/* Header dan filter */}
          <Row style={{ position: "relative", top: "-20px" }}>
            {/* Header */}
            <Col md="12">
              <div className="iq-navbar-header mb-4">
                <Row className="align-items-center mt-1">
                  {/* Kiri: Judul dan Info */}
                  <Col lg={8} md={12} className="mb-3 mb-lg-0">
                    <h2 className="text-white fw-bold mb-0">Ekspor Hasil Kelautan dan Perikanan</h2>
                    <h2 className="text-white mb-0">
                      {!isVisibleUpt ? `BPPMHKP` : namaUPT}
                    </h2>
                    <h3 className="text-light">
                      {/* {xAxis === 1 ? `Bulan ${selectedBulan}` : `Tahun ${selectedTahun}`} */}
                      {rangePeriode}
                    </h3>
                  </Col>

                  {/* Kanan: Form dan Dropdown */}
                  <Col lg={4} md={12}>
                    <Form.Group className="form-group mb-3">
                      <Form.Label
                        htmlFor="exampleInputdate"
                        className="text-white"
                      >
                        Periode
                      </Form.Label>
                      <div className="d-flex gap-2 flex-nowrap">
                        <Form.Control
                          type="date"
                          id="tanggalAwal"
                          value={tempStartDate}
                          onChange={(e) => setTempStartDate(e.target.value)}
                          style={{
                            backgroundColor: "transparent",
                            border: "1px solid #ccc",
                            minWidth: "140px",
                            color: "white",
                          }}
                        />
                        <Form.Control
                          type="date"
                          id="tanggalAkhir"
                          value={tempEndDate}
                          onChange={(e) => setTempEndDate(e.target.value)}
                          style={{
                            backgroundColor: "transparent",
                            border: "1px solid #ccc",
                            minWidth: "140px",
                            color: "white",
                          }}
                        />
                        <Button
                          type="button"
                          variant="primary"
                          className="whitespace-nowrap"
                          onClick={handleClickButton}
                        >
                          Tampilkan
                        </Button>
                      </div>
                    </Form.Group>

                    <div className="d-flex gap-3 flex-wrap">
                      <div className="d-flex align-items-center text-white">
                        <span>Bulan</span>
                        <Dropdown onSelect={handleSelect} className="ms-2">
                          <Dropdown.Toggle
                            as={Button}
                            variant="outline-light"
                            size="sm"
                          >
                            {selectedBulan}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {bulanTahun.map((bulan) => (
                              <Dropdown.Item
                                key={bulan.monthYear}
                                eventKey={bulan.monthYear}
                              >
                                {bulan.monthYear}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>

                      <div className="d-flex align-items-center text-white">
                        <span>Tahun</span>
                        <Dropdown onSelect={handleSelectTahun} className="ms-2">
                          <Dropdown.Toggle
                            as={Button}
                            variant="outline-light"
                            size="sm"
                          >
                            {selectedTahun}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {tahuns.map((tahun) => (
                              <Dropdown.Item
                                key={tahun.year}
                                eventKey={tahun.year}
                              >
                                {tahun.year}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          {/* Total Frequensi, Volume, nilai IDR dan nilai USD */}
          <Row className="g-3 mb-4 mt-2">
            {/* Card Item Component */}
            {[{
              icon: <FaChartBar size={24} />,
              bg: "bg-info",
              label: "Total Frekuensi",
              value: jumfreq,
              color: "text-dark",
              decimals: 0
            }, {
              icon: <FaCube size={24} />,
              bg: "bg-warning",
              label: "Total Volume (Ton)",
              value: jumVol / 1000,
              color: "text-dark",
              decimals: 2
            }, {
              icon: <FaMoneyBill size={24} />,
              bg: "bg-success",
              label: "Nilai IDR (Juta)",
              value: nilaiIDR / 1_000_000,
              color: "text-dark",
              decimals: 2
            }, {
              icon: <FaDollarSign size={24} />,
              bg: "bg-danger",
              label: "Nilai USD",
              value: nilaiUSD,
              color: "text-dark",
              decimals: 2
            }].map(({ icon, bg, label, value, color, decimals }, idx) => (
              <Col key={idx} lg="3" md="6">
                <Card className="h-100 shadow-sm rounded-4">
                  <Card.Body className="d-flex justify-content-between align-items-center">
                    <div className={`${bg} text-white rounded-3 p-3 d-flex align-items-center justify-content-center`}>
                      {icon}
                    </div>
                    <div className="d-flex flex-column align-items-end text-end" style={{ minWidth: 0 }}>
                      <div className="fw-semibold text-muted small">{label}</div>
                      <h4
                        className="mb-0 fw-bold text-nowrap"
                        style={{ fontSize: "1.5rem" }}
                        title={typeof value === "number" ? value.toLocaleString("id-ID") : "0"}
                      >
                        {typeof value === "number" && !isNaN(value) ? (
                          <CountUp
                            end={value}
                            duration={2.5}
                            decimals={decimals}
                            formattingFn={(val) => val.toLocaleString("id-ID")}
                          />
                        ) : (
                          <span>0</span>
                        )}
                      </h4>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <Row>
            {/* Chart Frequensi */}
            <Col md="12" lg="6">
              <Row>
                <Col md="12">
                  <div className="card">
                    <div className="flex-wrap card-header d-flex justify-content-between">
                      <div className="header-title">
                        <h5 className="card-title">Grafik Frekuensi Ekspor</h5>
                      </div>
                      <div className="d-flex align-items-center align-self-center"></div>
                    </div>
                    <div className="card-body">
                      {chartFrequensi && (
                        <Chart
                          options={chartFrequensi.options}
                          series={chartFrequensi.series}
                          type="area"
                          height="245"
                        />
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>

            {/* Chart Volume */}
            <Col md="12" lg="6">
              <Row>
                <Col md="12">
                  <div className="card">
                    <div className="flex-wrap card-header d-flex justify-content-between">
                      <div className="header-title">
                        <h5 className="card-title">Grafik Volume Ekspor</h5>
                      </div>
                      <div className="d-flex align-items-center align-self-center"></div>
                    </div>
                    <div className="card-body">
                      {chartVolume && (
                        <Chart
                          options={chartVolume.options}
                          series={chartVolume.series}
                          type="bar"
                          height="245"
                        />
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>

            {/* Chart Nilai Ekspor */}
            <Col md="12" lg="12">
              <Row>
                <Col md="12">
                  <div className="card">
                    <div className="flex-wrap card-header d-flex justify-content-between">
                      <div className="header-title">
                        <h5 className="card-title">Grafik Nilai Ekspor</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <NilaiExportChart
                        data={frequensi}
                        xAxis={xAxis}
                        colors={["#F59E0B", "#3B82F6"]}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>

            {/* Chart top Rank */}
            <Col md="12" lg="12">
              <Row>
                <Col md="12">
                  <div className="card">
                    <div className="flex-wrap card-header d-flex justify-content-between">
                      <div className="header-title">
                        <Row className="mb-3">
                          <Col>
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="secondary"
                                id="dropdown-kategori"
                                style={{
                                  backgroundColor: 'transparent',
                                  border: '1px solid #ccc',
                                  minWidth: '140px',
                                  color: 'black',
                                }}
                              >
                                Kategori : {labelMapKategori[commonKategori]}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {["negara", "upt", "trader", "kel_ikan"].map(item => (
                                  <Dropdown.Item
                                    key={item}
                                    onClick={() => setCommonKategori(item)}
                                  >
                                    {labelMapKategori[item]}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </Col>

                          <Col>
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="secondary"
                                id="dropdown-order"
                                style={{
                                  backgroundColor: 'transparent',
                                  border: '1px solid #ccc',
                                  minWidth: '140px',
                                  color: 'black',
                                }}
                              >
                                {/* Berdasarkan : {commonOrderBy.toUpperCase()} */}
                                Berdasarkan : {labelMapBerdasarkan[commonOrderBy]}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {["jumlah", "netto", "nilaiIDR", "nilaiUSD"].map(item => (
                                  <Dropdown.Item key={item} onClick={() => setCommonOrderBy(item)}>
                                    {labelMapBerdasarkan[item]}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </Col>

                          <Col>
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="secondary"
                                id="dropdown-limit"
                                style={{
                                  backgroundColor: 'transparent',
                                  border: '1px solid #ccc',
                                  minWidth: '140px',
                                  color: 'black',
                                }}
                              >
                                Limit : {commonLimit === 'all' ? 'SEMUA' : `TOP ${commonLimit}`}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item onClick={() => setCommonLimit('all')}>
                                  Semua
                                </Dropdown.Item>
                                {[5, 7, 10].map(item => (
                                  <Dropdown.Item key={item} onClick={() => setCommonLimit(item)}>
                                    TOP {item}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>

                          </Col>
                        </Row>
                      </div>
                      <div className="d-flex align-items-center align-self-center"></div>
                    </div>
                    <div className="card-body">
                      <div>
                        <ExportBarChart
                          data={commonExport}
                          kategori={commonKategori}
                          orderBy={commonOrderBy}
                          limit={commonLimit}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>


          </Row>

          <Row>
            {/* Chart Custom */}
            {/* <Col md="12" lg="6">
              <Row>
                <Col md="12">
                  <div className="card">
                    <div className="flex-wrap card-header d-flex justify-content-between">
                      <div className="header-title">
                        <Row className="mb-3">
                          <Col>
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="secondary"
                                id="dropdown-kategori"
                                style={{
                                  backgroundColor: 'transparent',
                                  border: '1px solid #ccc',
                                  minWidth: '140px',
                                  color: 'black',
                                }}
                              >
                                Kategori : {labelMapKategori[commonKategori]}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {["negara", "upt", "trader", "kel_ikan"].map(item => (
                                  <Dropdown.Item
                                    key={item}
                                    onClick={() => setCommonKategori(item)}
                                  >
                                    {labelMapKategori[item]}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </Col>

                          <Col>
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="secondary"
                                id="dropdown-order"
                                style={{
                                  backgroundColor: 'transparent',
                                  border: '1px solid #ccc',
                                  minWidth: '140px',
                                  color: 'black',
                                }}
                              >
                                Berdasarkan : {labelMapBerdasarkan[commonOrderBy]}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {["jumlah", "netto", "nilaiIDR", "nilaiUSD"].map(item => (
                                  <Dropdown.Item key={item} onClick={() => setCommonOrderBy(item)}>
                                    {labelMapBerdasarkan[item]}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </Col>

                          <Col>
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="secondary"
                                id="dropdown-limit"
                                style={{
                                  backgroundColor: 'transparent',
                                  border: '1px solid #ccc',
                                  minWidth: '140px',
                                  color: 'black',
                                }}
                              >
                                Limit : {commonLimit === 'all' ? 'SEMUA' : `TOP ${commonLimit}`}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item onClick={() => setCommonLimit('all')}>
                                  Semua
                                </Dropdown.Item>
                                {[5, 7, 10].map(item => (
                                  <Dropdown.Item key={item} onClick={() => setCommonLimit(item)}>
                                    TOP {item}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>

                          </Col>
                        </Row>
                      </div>
                      <div className="d-flex align-items-center align-self-center"></div>
                    </div>
                    <div className="card-body d-flex align-items-stretch">
                      <div style={{ flex: '0 0 50%' }}>
                        <ExportBarChart
                          data={commonExport}
                          kategori={commonKategori}
                          orderBy={commonOrderBy}
                          limit={commonLimit}
                        />
                      </div>
                      <div style={{ flex: '0 0 50%' }}>
                        <ExportDonutChart
                          data={commonExport}
                          kategori={commonKategori}
                          orderBy={commonOrderBy}
                          limit={commonLimit}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col> */}

            {/* Volume Per Bentuk */}
            {/* <Col lg="6">
              <Row>
                <Col md="12">
                  <div className="card">
                    <div className="flex-wrap card-header d-flex justify-content-between">
                      <div className="header-title">
                        <h5 className="card-title">Grafik Prosentase Volume Ekspro Per Bentuk Komoditas</h5>
                      </div>
                      <div className="d-flex align-items-center align-self-center"></div>
                    </div>
                    <div className="card-body">
                      {chartBentuk && (
                        <Chart
                          options={chartBentuk.options}
                          series={chartBentuk.series}
                          type="donut"
                          height="255"
                        />
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </Col> */}
          </Row>

        </Fragment>
      ) : (
        <Fragment>
          <Row>
            <Col md="12">
              <div className="d-flex justify-content-between flex-wrap iq-navbar-header mb-4">
                <div>
                  <h1 className="text-white">SIAP MUTU</h1>
                  <h3 className="text-light">
                    Sistem Informasi Aplikasi Pelayanan Mutu{" "}
                  </h3>
                </div>
              </div>
            </Col>
          </Row>
        </Fragment>
      )}
    </Fragment>
  );
});

export default DashEkspor;
